module.exports = __webpack_public_path__ + "static/img/cp_ddfl_logo.00dbcbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/cp_ddfl_logo.png
// module id = +9J7
// module chunks = 0